/**
 * アンカーリンクのスムーズスクロール
 *
 * a[href^="#"] のクリックを拾って、スムーズにスクロールする。
 * 純粋なJSのみで実装（jQueryは使わない）。
 */
export function initSmoothScroll() {
  document.addEventListener("click", (e) => {
    const target = e.target.closest('a[href^="#"]');
    if (!target) return;

    const href = target.getAttribute("href");
    if (!href || href === "#" || href.length < 2) return;

    const dest = document.querySelector(href);
    if (!dest) return;

    e.preventDefault();
    // 画面上端に貼り付くのはヘッダー .ha (position: sticky)。
    // その高さ + 88px (=8 余白 + 80px 上振り) を足して見出しの少し上で止める。
    const navHeight = document.querySelector(".ha")?.offsetHeight ?? 0;
    const offset = navHeight + 88;
    const top = dest.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: "smooth" });
  });
}
